import type { CampaignItem } from '../types';

/** Contagem por `sourceType` nos itens (útil para futuras pills por fonte ou agregação API). */
export function aggregateCampaignItemSourceTypes(items: CampaignItem[]): Record<string, number> {
  const out: Record<string, number> = {};
  for (const it of items) {
    const k = it.sourceType || 'unknown';
    out[k] = (out[k] || 0) + 1;
  }
  return out;
}
